import { lazy } from 'react';
// ----------------------------------------------------------------------

const PatientRealtionsPage = lazy(() => import('../pages/PatientRealtions.page'));
const Addpatient = lazy(() => import('../pages/Addpatient.page'));
const Viewpatient = lazy(() => import('../pages/Viewpatient.page'));
const EditPatientPage = lazy(() => import('../pages/Editpatient.page'));
const ComplaintsAndMsg = lazy(() => import('../pages/complaints-and-messages/ComplaintsAndMsg.pag'));
const AddComplaintPage = lazy(() => import('../pages/AddComplaint.page'));
const PatientCommunicationPage = lazy(() => import('../pages/patientCommunication.page'));
const ListMessage = lazy(() => import('../pages/ListMessage.page'));
const AddMessagePage = lazy(() => import('../pages/AddMessage.page'));
const MarketingPage = lazy(() => import('../pages/Marketing.page'));
const ArchivePage = lazy(() => import('../pages/Archive.page'));
// ----------------------------------------------------------------------

const PatientRealtionsRoutes = [
    {
        path: 'patient-relations',
        children: [
            { element: <PatientRealtionsPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: 'add-patient',
                element: <Addpatient />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'view-patient/:id',
                element: <Viewpatient />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'edit-patient/:id',
                element: <EditPatientPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'complaints-and-messages',
                children: [
                    {
                        element: <ComplaintsAndMsg />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add',
                        element: <AddComplaintPage />,
                        layout: 'default',
                        isAuthReq: true,
                    },
                ],
            },
            {
                path: 'patient-communication',
                children: [
                    {
                        element: <PatientCommunicationPage />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add-message',
                        children: [
                            { element: <AddMessagePage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <AddMessagePage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                    {
                        path: 'list-message',
                        children: [
                            { element: <ListMessage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <ListMessage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'archive',
                element: <ArchivePage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
    {
        path: 'marketing',
        element: <MarketingPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { PatientRealtionsRoutes };
